<template>
  <div class="progress mbr-progress">
    <div
      class="progress-bar mbr-progress__bar"
      :class="getClasses(color, variant)"
      :style="{ width: percentage + '%' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "MaterialProgress",
  props: {
    color: {
      type: String,
      default: "success",
    },
    variant: {
      type: String,
      default: "fill",
    },
    percentage: {
      type: Number,
      required: true,
    },
  },
  methods: {
    // Heritage Hearth has one bar tone (plus error); "gradient" renders like "fill"
    getClasses: (color) => {
      return color === "danger" ? "mbr-progress__bar--danger" : null;
    },
  },
};
</script>

<style scoped>
.progress.mbr-progress {
  height: 10px;
  overflow: hidden;
  background: var(--mbr-color-tint-dark);
  border-radius: var(--mbr-radius-full);
  box-shadow: none;
}

.progress-bar.mbr-progress__bar {
  height: 100%;
  background: var(--mbr-color-primary);
  border-radius: var(--mbr-radius-full);
  transition: width 0.5s ease;
}

.progress-bar.mbr-progress__bar--danger {
  background: var(--mbr-color-error);
}
</style>
